<script>
import { iAccordionItem, iAccordionItemSizes } from '@inscribe/signal';
import ProcessingEventsAccordion from '@/V2/components/processing-events/ProcessingEventsAccordion.vue';
import StatusCard from '@/V2/components/status/StatusCard.vue';
import { mapGetters } from 'vuex';
import { Statuses } from '@/V2/components/status/utils';

export default {
  components: {
    iAccordionItem,
    StatusCard,
    ProcessingEventsAccordion,
  },
  props: {
    document: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      iAccordionItemSizes,
      Statuses,
    };
  },
  computed: {
    ...mapGetters([
      'getCachedDocumentReviewAgentRunsForDocId',
      'getCachedProcessingEventsForDocumentId',
    ]),
    documentId() {
      return this.document?.id;
    },
    processingEvents() {
      const cached = this.getCachedProcessingEventsForDocumentId(
        this.documentId,
      );
      return cached?.data || [];
    },
    shouldShowAnalysisSteps() {
      return this.processingEvents.length > 0;
    },
  },
};
</script>

<template>
  <i-accordion-item
    :mount-open="true"
    title="Summary"
    :no-background="true"
    :size="iAccordionItemSizes.LARGE"
  >
    <div class="d-flex flex-column i-gap-8 i-mb-8">
      <status-card :state="Statuses.LOADING" label="Analyzing"></status-card>

      <processing-events-accordion
        v-if="shouldShowAnalysisSteps"
        title="Analysis Steps"
        :all-processing-events-finished="Boolean(document.risk_level)"
        :start-expanded="true"
        :processing-events="processingEvents"
      />
    </div>
  </i-accordion-item>
</template>
